import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const YearlyTrendsChart = ({ data }) => {
  const formatData = data
    .filter(item => item.year && !isNaN(parseInt(item.year)))
    .map(item => ({
      year: parseInt(item.year),
      homeless_cnt: parseInt(item.homeless_cnt) || 0,
      median_housing: parseInt(item.median_housing) || 0,
      unemployment_rate: parseFloat(item.unemployment_rate) || 0
    }))
    .sort((a, b) => a.year - b.year);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Yearly Trends</h3>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={formatData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="year"
              tick={{ fontSize: 12 }}
            />
            <YAxis
              yAxisId="left"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Homeless Count',
                angle: -90,
                position: 'insideLeft',
                style: { textAnchor: 'middle' }
              }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Median Housing Price ($)',
                angle: 90,
                position: 'insideRight',
                style: { textAnchor: 'middle' }
              }}
            />
            <YAxis
              yAxisId="unemployment"
              orientation="right"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Unemployment Rate (%)',
                angle: 90,
                position: 'outsideRight',
                offset: 80,
                style: { textAnchor: 'middle' }
              }}
            />
            <Tooltip />
            <Legend />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="homeless_cnt"
              stroke="#2563eb"
              name="Homeless Count"
              dot={true}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="median_housing"
              stroke="#7c3aed"
              name="Median Housing Price"
              dot={true}
            />
            <Line
              yAxisId="unemployment"
              type="monotone"
              dataKey="unemployment_rate"
              stroke="#047857"
              name="Unemployment Rate (%)"
              dot={true}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default YearlyTrendsChart;
